
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/contact/ir",
      function () {
        return require("private-next-pages/en/contact/ir/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/contact/ir"])
      });
    }
  